module.exports = __webpack_public_path__ + "img/p2.bca209d1.png";